import { PermissionError } from "libs/errors";
import { ActionServerContext } from "../action";

export async function authorizeUserHasAccessToThread(props: {
  threadId: string;
  context: ActionServerContext;
  includeSoftDeletes?: boolean;
}) {
  const { threadId, context, includeSoftDeletes } = props;
  const { loader } = context.environment;

  // Check if the user has permission to read the thread using the existing read authorization logic
  const [thread] = await loader.getRecord("thread", threadId, { includeSoftDeletes });

  if (!thread) {
    throw new PermissionError("User has no direct or transitive permission to thread");
  }
}
